import { memo } from 'react';
import { MagicIcon } from './Magic';
import './healing-backdrop.css';

export default memo(function HealingBackdrop() {
  return <div className="magic-backdrop healing-backdrop" aria-hidden="true">
    <div className="healing-warmth"/>
    {Array.from({length:18},(_,i)=><span className="healing-light" key={i} style={{left:`${(i*37+9)%98}%`,top:`${(i*23+7)%94}%`,'--delay':`${-i*1.9}s`,'--light-size':`${i%4===0?3:1.5}px`}}/>)}
    <div className="healing-background-heart"><MagicIcon name="healing-heart"/></div>
    <div className="healing-background-love"><MagicIcon name="heart"/></div>
    <svg className="healing-held-hands" viewBox="0 0 180 180" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="m8 116 29-25c9-7 16-8 24-6l24 7c8 3 7 12-2 13l-18-2m18 2 28 8c8 2 15 0 21-6l29-28m-137 64 23-18 37 12c12 4 20 3 28-4l32-27"/>
      <path d="m172 47-31 17c-6 3-11 7-15 12l-15 21c-6 8-13 5-10-3l8-19-18 8-14 7m32-15 18-6m-23 62 27 6 23-17"/>
      <path d="m42 94 5 29m104-57 11 19M27 101l14 29m98-58 11 22" strokeOpacity=".55"/>
      <path d="M88 56C75 46 67 40 67 32c0-11 15-15 21-5 6-10 21-6 21 5 0 8-8 14-21 24Z"/>
      <path d="M87 27v9l5 4-4 12M82 36h11m-10 9h10" stroke="#d7b17e"/>
      <path d="M44 55v8m-4-4h8m85 88v8m-4-4h8"/>
    </svg>
    <svg className="healing-embrace" viewBox="0 0 190 210" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M66 64c-16-8-18-30-4-39 14-10 29 1 29 16 0 12-11 23-25 23Zm51-1c16-6 23-25 13-36-11-13-30-6-33 9-3 13 6 25 20 27Z"/>
      <path d="M49 161c-8-21-13-48-7-70 4-16 16-24 28-21l29 12 24-11c14-5 26 7 29 24 4 24-4 48-9 65M75 69l-5 28 35 24c8 5 16-4 10-10L88 90m35-20 4 29-31 30c-7 7-17-1-10-9l20-23M69 103l-11 61m71-58 8 59"/>
      <path d="M39 167c32-11 74-11 112 0m-93 13c28-6 48-6 72 0" strokeOpacity=".4"/>
      <path d="M95 61c-7-6-13-10-13-15 0-7 9-9 13-3 4-6 13-4 13 3 0 5-6 9-13 15Z" stroke="#dfbb90"/>
      <path d="m45 41-7-3m8-7-4-6m108 23 8-4m-10-5 4-7" strokeOpacity=".5"/>
    </svg>
    <svg className="healing-garden" viewBox="0 0 1200 260" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M0 244c150-40 233-1 360-20s208-29 312-8 304-25 528 24" strokeOpacity=".35"/>
      {[0,1].map(i=><g key={i} transform={i?'translate(1200 0) scale(-1 1)':''}>
        <path d="M69 256c14-61 8-96 35-154m-25 90c-29-2-45-19-48-40 28 3 45 18 48 40Zm11-37c24-3 44-19 47-43-28 5-42 20-47 43Zm11-43c-16-6-24-23-23-42 19 7 28 23 23 42ZM151 250c-6-42 7-75 32-105m-20 45c-23-3-35-15-39-33 23 3 35 16 39 33Zm8-18c23 0 38-14 41-33-24 3-36 15-41 33Z"/>
        <path d="M103 73c-9-9-18-13-18-21 0-10 14-13 19-4 5-9 19-6 19 4 0 8-10 14-20 21Z" stroke="#c9988d"/>
        <path d="m45 214 4 5-4 5-4-5 4-5Zm153-113 3 4-3 4-3-4 3-4Z" stroke="#d5b17d"/>
      </g>)}
    </svg>
  </div>;
});
